import { TranslateSet } from './translate.model';

var languageValuesRO: TranslateSet = {
    languange: 'ro-RO',
    values: {
        language: 'Limba',
        expressionCalculator: 'Calculator de expresii',
        expressionName: 'Nume expresie',
        returnType: 'Tip rezultat',
        number: 'Numar',
        string: 'String',
        expression: 'Expresie',
        customFunctions: 'FuncÈii personalizate',
        fixedFunctions: 'FuncÈii predefinite',
        variables: 'Variabile',
        cancel: 'Anulare',
        submit: 'Trimite'
    },
};

export default languageValuesRO;